import PropTypes from 'prop-types';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Toolbar, LinearProgress, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { openComponentDrawer } from 'store/reducers/menu';
import Header from './Header';
// const FooterBlock = lazy(() => import('./FooterBlock'));

// ==============================|| Loader ||============================== //

const LoaderWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2001,
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2)
  }
}));

const Loader = () => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
  </LoaderWrapper>
);

// ==============================|| MINIMAL LAYOUT ||============================== //

const CommonLayout = ({ layout = 'blank' }) => {
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.menu);
  const { componentDrawerOpen } = menu;

  const handleDrawerOpen = () => {
    dispatch(openComponentDrawer({ componentDrawerOpen: !componentDrawerOpen }));
  };

  return (
    <Suspense fallback={<Loader />}>
      {layout === 'landing' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header layout={layout} />
          <Box component="main" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </Box>
        </Box>
      )}
      {layout === 'simple' && (
        <>
          <Header layout={layout} />
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </>
      )}
      {layout === 'component' && (
        <Container maxWidth="lg">
          <Header handleDrawerOpen={handleDrawerOpen} layout="component" />
          <Toolbar />
        </Container>
      )}
      {layout === 'blank' && <Outlet />}
    </Suspense>
  );
};

CommonLayout.propTypes = {
  layout: PropTypes.string
};

export default CommonLayout;
